import { api } from "../../services/NetworkBase";

export async function GetEtkRegistrationQueueOrders(searchText = "", orderStatus = "", startDate = "", endDate = "") {
	try {
		let response = await api
			.get(`vlp/etk-registration-queue?searchText=${encodeURIComponent(searchText)}&orderStatus=${encodeURIComponent(orderStatus)}&startDate=${startDate}&endDate=${endDate}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function EtkRegistrationQueueOrder(invoiceNumber) {
	try {
		let response = await api
			.get(`vlp/etk-registration-queue/${invoiceNumber}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function ApproveEtkRegistrationQueueOrder(id) {
	try {
		let response = await api
			.put(`vlp/etk-registration-queue/${id}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UpdateEtkRegistrationQueueOrder(invoiceNumber, item) {
	try {
		let response = await api
			.put(`vlp/etk-registration-queue/correct/${invoiceNumber}`, {
				json: item,
			})
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

//DeleteEtkRegistrationQueueOrder
export async function DeleteEtkRegistrationQueueOrder(id) {
	try {
	  let response = await api
		.delete(`vlp/etk-registration-queue/${id}`)
		.json();
	  return response;
	} catch (error) {
	  throw error;
	}
  }

